import { CollectionView } from 'backbone.marionette';
import TravelFlightOptionView from './item';


export default class TravelFlightOptionListView extends CollectionView {
    get childView () {
        return TravelFlightOptionView;
    }
}
